import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {DollarSign, Share2, BarChart3, Gift, CheckCircle, ArrowRight} from 'lucide-react'

const beneficios = [
  { icon: DollarSign, title: "Comissões atrativas", text: "Ganhe comissões competitivas por cada venda realizada através do seu link exclusivo de afiliado.", color: "#0E8EA0" },
  { icon: Share2, title: "Materiais prontos", text: "Receba materiais de divulgação profissionais, banners, textos e criativos para suas campanhas.", color: "#B038B2" },
  { icon: BarChart3, title: "Dashboard completo", text: "Acompanhe suas vendas, comissões e performance em tempo real através do painel do afiliado.", color: "#F5C542" },
  { icon: Gift, title: "Bônus e premiações", text: "Afiliados de destaque recebem bônus extras, premiações e condições especiais.", color: "#6CC4C4" },
]

const etapas = [
  { step: "1", title: "Cadastre-se", text: "Preencha o formulário de inscrição e aguarde a aprovação da equipe English Work." },
  { step: "2", title: "Receba seu link", text: "Após aprovação, você recebe seu link exclusivo de afiliado e materiais de divulgação." },
  { step: "3", title: "Divulgue", text: "Compartilhe o EW Pass com sua audiência usando seus materiais e link personalizado." },
  { step: "4", title: "Ganhe", text: "Receba comissões por cada venda realizada através do seu link de afiliado." },
]

export default function Afiliado() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Seja um Afiliado English Work"
        subtitle="Ganhe dinheiro divulgando o EW Pass e ajude mais pessoas a aprenderem inglês."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {beneficios.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-all duration-300 text-center group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-5 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-base font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-4xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" style={{ color: "#0E8EA0" }}>
            Como funciona
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {etapas.map((item) => (
              <div key={item.step} className="bg-white rounded-2xl p-6 border border-gray-100 text-center">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold mx-auto mb-4"
                  style={{ backgroundColor: "#B038B2" }}
                >
                  {item.step}
                </div>
                <h3 className="text-base font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <a
              href="/fale-conosco"
              className="inline-flex items-center gap-2 px-8 py-4 text-white font-bold rounded-full text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
              style={{ backgroundColor: "#B038B2" }}
            >
              Quero ser afiliado <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
